module.exports = __webpack_public_path__ + "static/media/listimage.5ecbb437.svg";